import { Field, Float, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'

@InputType()
export class PurchaseCreditsArgs extends ActionArgs {
  /** Target owner for this purchase — a `User._id` (User scope) or a `Tenant._id` (Tenant scope). */
  @Field(() => ID)
  ownerId: string

  @Field(() => Float)
  credits: number

  /** Currency the purchase was charged in — rejected if it differs from an existing account's currency. */
  @Field(() => String)
  currency: string

  /** The settled `CreditPurchase._id` — recorded on `CreditTransaction.creditPurchaseId` (ledger idempotency) and `.reason`. */
  @Field(() => ID)
  creditPurchaseId: string
}
